import { render, staticRenderFns } from "./RecsSkeleton.vue?vue&type=template&id=288108af&"
import script from "./RecsSkeleton.vue?vue&type=script&lang=js&"
export * from "./RecsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports